import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostTranslationHistoryDownloadXml } from '../../../../api/translations/translations';
import { useOptionsForBinary } from '../../../../hooks/api';
import { executeDownload } from '../../../../utils/download';
import BlobErrorModal from '../../../modules/BlobErrorModal';
import SpinnerModal from '../../../modules/SpinnerModal';

type Props = {
  translationHistoryId: number;
};
function ProductionTranslationsDownloadModal({ translationHistoryId }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [displayDownloadError, setDisplayDownloadError] = useState(false);
  const optionsForBinary = useOptionsForBinary(language);

  const {
    mutateAsync: _downloadAsync,
    isError: downloadIsError,
    error: downloadError,
    isLoading: downliadIsloading,
  } = usePostTranslationHistoryDownloadXml<AxiosError<Blob>>(optionsForBinary);

  useEffect(() => {
    setDisplayDownloadError(downloadIsError);
  }, [downloadIsError]);
  // ダウンロード処理
  const downloadAsync = useCallback(async () => {
    await _downloadAsync(
      { data: {translation_history_id: translationHistoryId} },
      {
        // API アクセスが成功したら、ダウンロードを実行
        onSuccess: (response) => executeDownload(response),
      }
    );
  }, [translationHistoryId, _downloadAsync]);

  return (
    <>
      <li onClick={() => downloadAsync()} style={{ cursor: 'pointer', fontSize: '12px' }}>
        <i className="fa-solid fa-download" />
        {t('ダウンロード')}
      </li>
      {/* スピナーモーダル */}
      {downliadIsloading && <SpinnerModal />}
      {/* 出力エラー */}
      {displayDownloadError && (
        <BlobErrorModal
          error={downloadError}
          onClickOk={() => {
            setDisplayDownloadError(false);
          }}
        />
      )}
    </>
  );
}

export { ProductionTranslationsDownloadModal };
